import { c as _c } from "react/compiler-runtime";
import { DateLocalizer } from "react-big-calendar";
interface CalendarHeaderProps {
  date: string;
  localizer: DateLocalizer;
}
export default function CalendarHeader(t0) {
  const $ = _c(7);
  const {
    date,
    localizer
  } = t0;
  let t1;
  if ($[0] !== date || $[1] !== localizer) {
    t1 = localizer.format(new Date(date), "D ddd");
    $[0] = date;
    $[1] = localizer;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const label = t1;
  const isToday = new Date(date).toDateString() === new Date().toDateString();
  if (isToday) {
    let t2;
    if ($[3] !== label) {
      t2 = <div className="rounded-full font-medium text-sm text-primary-700">{label}</div>;
      $[3] = label;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== label) {
    t2 = <div className="rounded-full font-thin text-sm text-gray-700">{label}</div>;
    $[5] = label;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}